import { ChangeDetectorRef, Component, ElementRef, Input, SimpleChanges } from '@angular/core';
import { TableComponent } from '../table/table.component';
import { SharedService } from '../../modules/shared-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import config from 'config/default.json';
import { ApiServiceModule } from '../../modules/api-service.module';
import { HelperModule } from '../../modules/helper.module';
import { SettingAdvertismentComponent } from './setting-advertisment/setting-advertisment.component';

@Component({
  selector: 'app-advertisment',
  templateUrl: './advertisment.component.html',
  styleUrls: ['./advertisment.component.scss', '../../components/table/table.component.scss']
})
export class AdvertismentComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() advertismentData:{[x: string]: any}[] = [];
  @Input() platformInfos: { [x:string]: any } = new Map();
  promoTypes: any[] = [];
  ndApiUrl = config.master.ndapi.url;
  

  ngOnInit() {
    this.setData();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['advertismentData'] && !changes['advertismentData'].firstChange) {
      this.setData();
    }
  }
  setData(){
    this.dataSource = this.advertismentData.map((row) => {
      return row;
    });
    this.promoTypes = Array.from(new Set(this.advertismentData.map(el=>el['promo_type'])));
    this.showedRows = this.dataSource;
  }
  loadAdvertismentData(){
    this.sharedService.sendData({in_progress: true});
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/advertisment/load', {id_user: this.userInfos['id_user'], platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response: any)=>{
      this.dataSource = response.map((row:any) => {
        row['active_format'] = this.buildTagsHtml(row.active.toString());
        return row;
      });
      this.showedRows = this.dataSource
      this.sharedService.sendData({in_progress: false});
    })
  }
  settingAdvertisment(action:string, rowInfos: any){
    const dialogRef = this.dialog.open(SettingAdvertismentComponent, {
      width: '70%',
      position: {top: '30px' },
      data: {action: action, promo_types: this.promoTypes, row_infos: rowInfos, user_infos: this.userInfos, platform_infos: this.platformInfos}
    });
    dialogRef.afterClosed().subscribe((response:any) => {
  
    });
  }
  setUpdateAdvertisment(data:any){
    this.dataSource = this.dataSource.map((element:any) => {
      if (element.id == data.id) {
        element.begin_date = data.begin_date;
        element.expiration_date = data.expiration_date;
      }
      return element;
      });

    this.showedRows = this.showedRows.map((element:any) => {
      if (element.id == data.id) {
        element.begin_date = data.begin_date;
        element.expiration_date = data.expiration_date;
      }
      return element;
      });
  }
  
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
    }
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
  setWaiting(value:any){
    this.sharedService.sendData({in_progress: value});
  }
}
